<template>
  <el-dialog title="请求特价审批" :visible.sync="disableDialog" min-width="70%">
    <div style="color:rgba(131,135,138,1);">请对申请产品填写期望价格，审核通过后，将以您所提交的期望特价进行供货；</div>
    <el-table
      style="margin-top:20px;"
      ref="tableRefs"
      :data="list"
      stripe
      tooltip-effect="dark"
      :header-cell-style="tableHeader"
      v-loading="loadingTable"
      element-loading-text="拼命加载中请稍后..."
      element-loading-spinner="el-icon-loading"
      border
    >
      <el-table-column prop="brandName" label="品牌" show-overflow-tooltip></el-table-column>
      <el-table-column prop="seriesName" label="系列" show-overflow-tooltip></el-table-column>
      <el-table-column prop="proType" label="型号" show-overflow-tooltip></el-table-column>
      <el-table-column prop="orderNumber" label="订货号" min-width="85" show-overflow-tooltip></el-table-column>
      <el-table-column prop="ocUnit" label="单位" width="50"></el-table-column>
      <el-table-column prop="ocNeednumber" label="数量" width="85"></el-table-column>
      <el-table-column prop="orderNumber" label="期望货期" width="80" show-overflow-tooltip>
        <template slot-scope="scope">{{scope.row.ocExtime}}天</template>
      </el-table-column>
      <el-table-column label="期望价格" min-width="100">
        <template slot-scope="scope">
          <el-input
            oninput="value=value.replace(/[^0-9.]/g,'')"
            v-model="scope.row.specialPrice"
            @input="onInputPrice(scope.row)"
          ></el-input>
        </template>
      </el-table-column>
      <el-table-column label="折扣率" min-width="110">
        <template slot-scope="scope">
          <el-row>
            <el-col :span="20">
              <el-input
                oninput="value=value.replace(/[^0-9.]/g,'')"
                v-model="scope.row.proDiscount"
                @input="onInputDiscount(scope.row)"
              ></el-input>
            </el-col>
            <el-col :span="4">%</el-col>
          </el-row>
        </template>
      </el-table-column>
      <el-table-column prop="ocUnitPrice" label="供货单价">
        <template slot-scope="scope">{{ scope.row.ocUnitPrice | priceFilter}}</template>
      </el-table-column>
      <el-table-column prop="ocFacePrice" label="面价">
        <template slot-scope="scope">{{ scope.row.ocFacePrice | priceFilter}}</template>
      </el-table-column>
    </el-table>
    <el-form>
      <el-form-item label="备注：" :rules="filter_rules({required:true,type:'change'})">
        <el-input type="textarea" :rows="4" placeholder="请求特价审批审批原因" v-model="mark"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button type="primary" @click="onSubmit" :disabled='isBut'>确 定</el-button>
      <el-button @click="disableDialog = false">取 消</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { customerSpecialPriceAdd } from '@/api/customer/customerManage'
export default {
  data () {
    return {
      disableDialog: false,
      loadingTable: false, // 列表loading
      mark: '', // 申请原因
      list: [],
      isBut: false
    }
  },
  methods: {
    // 调入报价单初始化方法
    onInitial (val) {
      this.list = []
      this.mark = ''
      val.forEach((ele) => {
        ele.specialPrice = ele.ocUnitPrice
        ele.proDiscount = ((+ele.specialPrice / +ele.ocFacePrice) * 100).toFixed(2)
      })
      this.list = JSON.parse(JSON.stringify(val))
      this.disableDialog = true
    },
    // 计算 折扣率
    onInputPrice (row) {
      row.proDiscount = row.specialPrice
        ? ((+row.specialPrice / +row.ocFacePrice) * 100).toFixed(2)
        : null
    },
    // 计算 期望价格
    onInputDiscount (row) {
      row.specialPrice = row.proDiscount
        ? ((+row.proDiscount / 100) * +row.ocFacePrice).toFixed(2)
        : null
    },
    // 确定
    onSubmit () {
      if (!this.mark) {
        this.$message.error('备注不可为空！')
        return
      }
      // 由于后端特价审批接口接收参数与产品信息列表返回的数据字段不一样,所以需要前端重新赋值处理
      let isBall = false
      var temp = JSON.parse(JSON.stringify(this.list))
      temp.forEach((item) => {
        item.proDiscount = item.proDiscount / 100
        item.proPrice = item.ocFacePrice
        if (!item.specialPrice || !item.proDiscount) {
          isBall = true
        }
      })
      if (isBall) {
        this.$message.error('期望价格和折扣率不可为空！')
        return
      }
      this.isBut = true
      const params = {
        customerSpecialPriceManuaVoList: temp,
        obId: this.$route.query.id,
        mark: this.mark
      }
      customerSpecialPriceAdd(params)
        .then((res) => {
          if (res.data.code === 200) {
            this.$message.success('操作成功')
          } else {
            this.$message.error(res.data.msg)
          }
          this.isBut = false
          this.disableDialog = false
        })
        .catch((err) => {
          console.log(err)
        })
    },
    // 设置头部背景色
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  }
}
</script>
